import {UseQueryOptions} from '@tanstack/react-query';
import {useMemo} from 'react';
import brandFetchers from '@/api/fetchers/brand';
import useDataQuery from '@/hooks/use-data-query';

interface UseCampaignsV2ListQueryParams<TData, TError = unknown>
  extends UseQueryOptions<TData, TError> {
  brandId?: string;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
  states?: string[];
}

export type CampaignListItem = {
  id: string;
  name: string;
  imageUrl: string;
  network: string;
  state: string;
  createdAt: string;
  launchedOn: Date | string | undefined;
  newMessagesCount: number;
  newApplicationsCount: number;
  assetsCount: number;
  generatedByBriefAi: boolean;
};

function useCampaignsV2ListQuery<TData, TError = unknown>({
  brandId,
  refetchOnWindowFocus = true,
  states = [],
  ...rest
}: UseCampaignsV2ListQueryParams<TData, TError>) {
  const response = useDataQuery({
    queryKey: ['campaignsV2List', {brandId, states}],
    queryFn: brandFetchers.brandCampaignsV2List,
    enabled: !!brandId,
    meta: {
      brandId,
      state: states?.length ? states.join(',') : undefined,
    },
    refetchOnWindowFocus,
    ...rest,
  });

  const campaigns = useMemo(() => {
    return (response.data || []) as CampaignListItem[];
  }, [response.data]);

  return {
    ...response,
    campaigns,
  };
}

export default useCampaignsV2ListQuery;
